'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_TIMEOUT = exports.DEFAULT_TIMEOUT = 60000;